import { Modal } from 'components';
import { FC, useState } from 'react';

import ModalContentStyled from './styles';

const ModalUploadImage: FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const cancelButton = {
    text: 'キャンセル',
    onClick: handleCancel,
  };
  const okButton = { text: '確定', onClick: handleOk };
  return (
    <>
      <button onClick={showModal}>Modal Upload Image</button>
      <Modal
        visible={isModalVisible}
        title="選択した写真をアップロードします"
        okButton={okButton}
        cancelButton={cancelButton}
        width={640}
      >
        <ModalContentStyled>この操作は元に戻せません。</ModalContentStyled>
      </Modal>
    </>
  );
};

export default ModalUploadImage;
